
export default modelClass => {
  return (state = false, { type, payload }) => {
    if (type === 'FIREBASE_LOADING' && payload.model === modelClass) {
      return payload.isLoading
    }
    return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/firebase/loadingReducer.js